import { render, staticRenderFns } from "./UnsupportedBankPopup.vue?vue&type=template&id=974c0608&scoped=true"
import script from "./UnsupportedBankPopup.vue?vue&type=script&lang=js"
export * from "./UnsupportedBankPopup.vue?vue&type=script&lang=js"
import style0 from "./UnsupportedBankPopup.vue?vue&type=style&index=0&id=974c0608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974c0608",
  null
  
)

export default component.exports